/*
 *   File : goal-investments.js
 *   Author : https://evoqins.com
 *   Description : Investments with goals List
 *   Version : 1.0.0
*/

// Packages
import { useEffect, useState } from "react";

// Custom components
import { InfoCard } from "../../../Components/Cards";
import { DataTableContainer } from "../../../Components/DataTable";
import { EmptyScreen } from "../../../Components/Others";

// Custom styles
import Colors from '../../../Styles/color.module.scss';

// Services
import APIService from "../../../Services/api-service";

// Table custom style
const TABLE_STYLE = {
    table: {
        style: {
            borderRadius: "0px",
        },
    },

    headRow: {
        style: {
            borderBottomColor: 'transparent',
            paddingLeft: "32px",
            color: Colors.dark_gray,
            fontFamily: "Montserrat-Bold",
            fontSize: "14px",
            lineHeight: "18px",
            paddingTop: "0px",
            paddingBottom: '0px',
            minHeight: "32px"
        }
    },
    rows: {
        style: {
            paddingLeft: "32px",
            borderBottom: 'none !important',
            '&:nth-child(odd)': {
                backgroundColor: '#0D0D0D05',
            },

        },
    },
    cells: {
        style: {
            paddingTop: '16px',
            paddingBottom: '16px',
            color: Colors.dark_charcoal,
            fontFamily: "Montserrat-Medium",
            fontSize: "14px",
            lineHeight: "20px",
            paddingLeft: "0px",
            userSelect: "none",
        }
    },
    headCells: {
        style: {
            paddingLeft: "0px"
        }
    },
    pagination: {
        style: {
            paddingRight: "50px"
        }
    }
};

const GoalInvestments = (props) => {

    const [investmentData, setInvestmentData] = useState([]);
    const [loader, setLoader] = useState(true);

    useEffect(() => {
        _getInvestmentData();
        //eslint-disable-next-line
    }, []);

    // API - non investment data
    const _getInvestmentData = () => {
        const url = "/user/goal-summary";
        const request = {
            customer_id: props.id,
        }
        APIService(true, url, request).then((response) => {
            if (response.status_code === 200) {
                setInvestmentData(response.data);
            }
            else {
                setInvestmentData([]);
            }
            setLoader(false);
        });
    }

    const GOAL_COLUMNS = [
        {
            name: "Invested funds",
            cell: row => <div className="d-flex align-items-center">

                <span className="ps-2">{row.scheme_name}</span>
            </div>,
            width: "70%"
        },
        {
            name: "Amount",
            width: "110px",
            cell: row => row.invested_amount
        },
        {
            name: "Allocation",
            cell: row => row.allocation ? `${row.allocation}%` : `0%`
        }
    ]


    return (

        loader === true ?
            <div className="h-80vh d-flex align-items-center justify-content-center">
                <img src={require("../../../Assets/Images/Loader/page-loader.gif")}
                    alt={"loader"}
                    width={60}
                    height={60}
                />
            </div>
            :
            investmentData.length === 0 ?
                <div className="bg-white border-radius-24px padding-32px-tb mt-4">
                    <EmptyScreen className="my-5"
                        title="No investments found"
                        image={require("../../../Assets/Images/Empty/no-data.png")}
                        description="Lorem Ipsum has been the industry's standard dummy text ever since the 1500s" />
                </div>
                :
                investmentData.map((item, key) =>
                    <div className="bg-white border-radius-24px padding-32px-tb mt-4"
                        key={key}>
                        <h4 className="e-font-16 e-line-height-20 e-montserrat-semi-bold color-gunmetal-gray mb-4 padding-32px-lr">
                            Milestone: {item.name}
                        </h4>

                        <div className="padding-32px-lr">
                            <div className="row padding-32px-bottom">
                                <div className="col-lg-3 col-sm-6 col-12 mb-lg-0 mb-3">
                                    <InfoCard type={2}
                                        title="Target amount"
                                        data={item.target} />
                                </div>
                                <div className="col-lg-3 col-sm-6 col-12 mb-lg-0 mb-3">
                                    <InfoCard type={2}
                                        title="AUM"
                                        data={item.aum} />
                                </div>
                                <div className="col-lg-3 col-sm-6 col-12 mb-lg-0 mb-3">
                                    <InfoCard type={2}
                                        title="Current value"
                                        data={item.current_value} />
                                </div>
                                <div className="col-lg-3 col-sm-6 col-12 mb-lg-0 mb-3">
                                    <InfoCard type={2}
                                        title="Total returns"
                                        color={item.returns < 0 ? "color-red" : item.returns > 0 ? "color-emerald-green" : ""}
                                        data={item.returns} />
                                </div>
                            </div>
                        </div>

                        {item.funds && <DataTableContainer data={item.funds}
                            columns={GOAL_COLUMNS}
                            customStyles={TABLE_STYLE} />}
                    </div>
                )

    )
}

export default GoalInvestments;